import React, { useState } from 'react'
import { Switch } from '@mui/material'

import { withStyles } from '@mui/styles'

import { useCampaignsContext } from '../../contexts'
import { campaignStateSwitchStyles } from './campaign-state-switch.styles'

export const CampaignStateSwitch = withStyles(campaignStateSwitchStyles)(({
  classes,
  ...props
}) => {
  const { changeCampaignStatus } = useCampaignsContext()

  if (!props.rowData) {
    return null
  }

  const state = props.rowData['activa']
  const campaignId = props.rowData['id']

  const [loading, setLoading] = useState(false)

  const handleToggleState = (e) => {
    e.stopPropagation()
    setLoading(true)
    changeCampaignStatus(campaignId, { activa: e.target.checked })
      .then(() => {
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Switch classes={classes} checked={state} disabled={loading} onChange={handleToggleState} />
    </div>
  )
})
